import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  sectionHeading: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column nowrap',
  },
  sectionDescription: {
    margin: theme.spacing(2, 0),
    textAlign: 'center',
    display: 'flex',
  },
  productInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: '80px',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(3),
      flexDirection: 'column',
      '& > div': {
        width: '100% !important',
      },
    },
  },
}))
